package com.wintermar.inspection.feature.data.local.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.Transacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlPreparedStatement

class NoOpDriver : SqlDriver {
    override fun execute(
        identifier: Int?,
        sql: String,
        parameters: Int,
        binders: (SqlPreparedStatement.() -> Unit)?
    ): QueryResult<Long> = QueryResult.Value(0L)

    override fun <T> executeQuery(
        identifier: Int?,
        sql: String,
        mapper: (SqlCursor) -> QueryResult<T>,
        parameters: Int,
        binders: (SqlPreparedStatement.() -> Unit)?
    ): QueryResult<T> = error("Not supported on Web Mock")

    override fun newTransaction(): QueryResult<Transacter.Transaction> = error("Not supported")
    override fun currentTransaction(): Transacter.Transaction? = null
    override fun addListener(
        vararg queryKeys: String,
        listener: Query.Listener
    ) {
    }

    override fun removeListener(
        vararg queryKeys: String,
        listener: Query.Listener
    ) {
    }

    override fun close() {}
    override fun notifyListeners(vararg queryKeys: String) {}
}
